import { useMutation, useQueryClient } from 'react-query';
import { apiClient, endpoints } from '../api/client';

export const forgetExtensionWorkerCapability = async (
  workerId: string,
  marketplaceKey: string
): Promise<void> => {
  await apiClient.delete(
    `${endpoints.extensionWorkers}/${workerId}/capabilities/${encodeURIComponent(marketplaceKey)}`
  );
};

export const useForgetExtensionWorkerCapability = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ workerId, marketplaceKey }: { workerId: string; marketplaceKey: string }) =>
      forgetExtensionWorkerCapability(workerId, marketplaceKey),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('extensionWorkers');
      },
    }
  );
};
